/**
 * Evaluates whether a question should be visible based on its conditions.
 *
 * Each condition references another question's current value:
 *   { field: "profession", op: "eq",    value: "student" }
 *   { field: "profession", op: "not",   value: "student" }
 *   { field: "workplace",  op: "in",    value: ["clinic", "school"] }
 *   { field: "workplace",  op: "notIn", value: ["clinic", "school"] }
 *
 * All conditions must pass (logical AND) for the question to be visible.
 */
export function isQuestionVisible(question, formValues) {
  if (!question.conditions || question.conditions.length === 0) return true;

  return question.conditions.every((condition) => {
    const current = formValues[condition.field];

    switch (condition.op) {
      case "eq":
        return current === condition.value;
      case "not":
        return current !== condition.value;
      case "in":
        return Array.isArray(current) && condition.value.some((v) => current.includes(v));
      case "notIn":
        return !Array.isArray(current) || !condition.value.some((v) => current.includes(v));
      default:
        return true;
    }
  });
}
